import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import { SectionDivider, PageTitle, HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';
import SelectRolePageContent from '../PageContent/SelectRolePageContent';

const SelectRole = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="lg" backButton={false}>
            <PageTitle heading="Please select the best option." />
            <SectionDivider extraPaddingClass="pb-25" width="70%" />
            <SelectRolePageContent />
        </HeaderAndBodyLayout>
    )
}
export default SelectRole;